module.exports = __webpack_public_path__ + "static/media/defaultAvatar25.f385c038.svg";